import { NgModule, Optional, SkipSelf } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UIRouterModule } from '@uirouter/angular';

import { CommonFiltersToUrlService } from './filters_to_url.service';
import { CommonFiltersFromUrlService } from './filters_from_url.service';

@NgModule({
	providers: [
		CommonFiltersToUrlService,
		CommonFiltersFromUrlService,
	],
	imports: [
		CommonModule,
		UIRouterModule.forChild(),
	],
})
export class CommonUrlFiltersModule {
	constructor (
		@Optional() @SkipSelf() module?: CommonUrlFiltersModule,
	) {
		if (module) {
			throw new Error('CommonUrlFiltersModule is already loaded. Import it in the AppModule only');
		}
	}
}
